import React from 'react';

interface Props {
  embed: string;
}

const HubSpotCta: React.FC<Props> = ({ embed }) => {
  if (!embed) return null;

  return (
    // eslint-disable-next-line react/no-danger
    <div dangerouslySetInnerHTML={{ __html: embed }} />
  );
};

export default HubSpotCta;
